import { EMPTY } from 'rxjs';
import { catchError, finalize, switchMap, tap } from 'rxjs/operators';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, NonNullableFormBuilder } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Line } from '../models/line.model';
import { Vlan } from '../models/vlan.model';
import { ModemChoiceService } from '../modem-choice.service';

@UntilDestroy()
@Component({
  selector: 'mprd-modem-choice-vlan',
  templateUrl: './modem-choice-vlan.component.html',
})
export class ModemChoiceVlanComponent implements OnInit {
  @Input() line!: Line;
  @Output() updated = new EventEmitter<Vlan>();
  pending = false;
  form: FormGroup<{ vlan: FormControl<Vlan> }>;
  readonly MODES: Vlan[] = ['SINGLE', 'TRIPLE'];

  constructor(
    private fb: NonNullableFormBuilder,
    private modemChoiceService: ModemChoiceService,
  ) {
    this.form = this.fb.group({
      vlan: this.fb.control<Vlan>('TRIPLE'),
    });
  }

  ngOnInit(): void {
    this.vlan.setValue(this.line.vlanMode);
    if (this.line.vlanMode === 'SINGLE') {
      this.vlan.disable();
    }

    this.vlan.valueChanges
      .pipe(
        tap(() => (this.pending = true)),
        switchMap((vlan) =>
          this.modemChoiceService
            .updateVlan(this.line.circuitId, { vlanMode: vlan })
            .pipe(
              tap(() => {
                this.updated.emit(vlan);
                if (vlan === 'SINGLE') {
                  this.vlan.disable({ emitEvent: false });
                }
              }),
              catchError(() => {
                const previousVlan = vlan === 'SINGLE' ? 'TRIPLE' : 'SINGLE';
                this.vlan.setValue(previousVlan, { emitEvent: false });
                return EMPTY;
              }),
              finalize(() => (this.pending = false)),
            ),
        ),
        untilDestroyed(this),
      )
      .subscribe();
  }

  get vlan(): FormControl<Vlan> {
    return this.form.controls.vlan;
  }
}
